<div class="sidebar-wrapper sidebar-theme">
  <nav id="sidebar">
    <div>
      <ul
        class="navbar-item theme-brand flex-row align-center justify-content-center text-center nav-custom"
      >
        <li class="nav-item theme-logo">
          <a href="index.html">
            <img [src]="currentLogo" class="navbar-logo logo-img" alt="logo" />
          </a>
        </li>
      </ul>
      <ul class="list-unstyled menu-categories" id="accordionExample">
        <li class="menu">
          <a
            routerLink="/home"
            aria-expanded="false"
            class="dropdown-toggle portada"
          >
            <div class="">
              <i class="icon dashboard"></i>
              <span style="font-weight: 700">{{
                'menu.dashboard' | translate
              }}</span>
            </div>
          </a>
        </li>
        <li class="menu" *ngIf="showMicrosoftPurview">
          <a
            href="#microsoftPurview"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle drop info-protection-menu"
            style="margin-top: 15px"
          >
            <div class="">
              <i class="icon purview"></i>
              <span>{{ 'microsoftPurview.microsoftPurview' | translate }}</span>
            </div>
            <div>
              <i class="las la-angle-right sidemenu-right-icon"></i>
            </div>
          </a>
          <ul
            class="collapse submenu list-unstyled info-protection-submenu"
            id="microsoftPurview"
            data-parent="#accordionExample"
          >
            <li>
              <a
                class="subicon sub-database"
                routerLink="/home/MicrosoftPurview/DataClasification"
              >
                {{ 'menu.administration.dataClasify' | translate }}
              </a>
            </li>
            <li>
              <a
                class="subicon sub-folder"
                routerLink="/home/MicrosoftPurview/DataClasify"
              >
                {{ 'menu.administration.clasifyLabels' | translate }}
              </a>
            </li>
            <li>
              <a
                class="subicon sub-clipboard"
                routerLink="/home/MicrosoftPurview/InformationProtection"
              >
                {{ 'menu.administration.confidentialityLabels' | translate }}
              </a>
            </li>
            <li>
              <a
                class="subicon sub-window"
                routerLink="/home/MicrosoftPurview/ComplianceManager"
              >
                {{ 'menu.administration.dpoComplianceDashboard' | translate }}
              </a>
            </li>
          </ul>
        </li>
        <li class="menu">
          <a
            href="#informes"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle drop"
          >
            <div class="">
              <i class="icon reports"></i>
              <span>{{ 'menu.reports.reports' | translate }}</span>
            </div>
            <div>
              <i class="las la-angle-right sidemenu-right-icon"></i>
            </div>
          </a>
          <ul
            class="collapse submenu list-unstyled"
            id="informes"
            data-parent="#accordionExample"
          >
            <li>
              <a class="subicon sub-report" routerLink="/home/informes/irm">
                {{ 'menu.reports.cioReport' | translate }}
              </a>
            </li>
            <li>
              <a class="subicon sub-report" routerLink="/home/informes/dlp">
                {{ 'menu.reports.dpoReport' | translate }}
              </a>
            </li>
            <li>
              <a
                class="subicon sub-report"
                routerLink="/home/informes/FilesControl"
              >
                {{ 'menu.reports.reportDocuments' | translate }}
              </a>
            </li>
            <li>
              <a class="subicon sub-report" routerLink="/home/informes/ia">
                {{ 'menu.reports.iaReport' | translate }}
              </a>
            </li>
            <!-- WIP, oculto hasta que este listo (ver automated-reports.component.ts)
            <li>
              <a class="subicon sub-report" routerLink="/home/informes/automated-reports">
                {{ 'menu.reports.monthlyAutomated' | translate }}
              </a>
            </li>
            -->
            <li>
              <a
                class="subicon las la-download"
                style="font-size: 16px"
                routerLink="/home/informes/descargas"
              >
                <span
                  style="
                    font-family: inter;
                    font-weight: 400;
                    font-size: 13px !important;
                  "
                  >{{ 'menu.reports.downloads' | translate }}</span
                ></a
              >
            </li>
          </ul>
        </li>
        <li class="menu">
          <a
            class="dropdown-toggle drop"
            routerLink="/home/InformationProtection/CompanyDocuments"
          >
            <div class="">
              <i class="las la-folder-open"></i>
              <span>{{ 'menu.administration.companyDocuments' | translate }}</span>
            </div>
          </a>
        </li>
        <li class="menu" *ngIf="isSuperAdmin">
          <a
            href="#admin"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle drop"
          >
            <div class="">
              <i class="icon admin"></i>
              <span>{{
                'menu.administration.administration' | translate
              }}</span>
            </div>
            <div>
              <i class="las la-angle-right sidemenu-right-icon"></i>
            </div>
          </a>
          <ul
            class="collapse submenu list-unstyled"
            id="admin"
            data-parent="#accordionExample"
          >
            <li>
              <a class="subicon sub-company" routerLink="/home/Admin/Company">
                {{ 'menu.administration.companies' | translate }}
              </a>
            </li>
            <li>
              <a class="subicon sub-report" routerLink="/home/informes/logs">
                {{ 'menu.reports.logs' | translate }}
              </a>
            </li>
          </ul>
        </li>
        <li class="menu">
          <a
            href="#manuales"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle drop"
          >
            <div class="">
              <i class="icon manual"></i>
              <span>{{ 'menu.manuals.manuals' | translate }}</span>
            </div>
            <div>
              <i class="las la-angle-right sidemenu-right-icon"></i>
            </div>
          </a>
          <ul
            class="collapse submenu list-unstyled"
            id="manuales"
            data-parent="#accordionExample"
          >
            <li>
              <a
                class="subicon sub-manuals"
                routerLink="/home/manual/procedures"
              >
                {{ 'menu.manuals.procedures' | translate }}
              </a>
            </li>
            <li>
              <a class="subicon sub-manuals" routerLink="/home/manual/users">
                {{ 'menu.manuals.userManuals' | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="logo-container">
      <img
        class="logo-safecloud-1"
        src="../../assets/img/safecloud-1.png"
        alt="logo"
      />
    </div>
  </nav>
</div>
